import React from "react";

import { SectionTitle } from "./common";
import { MenuItem } from "components/ui/menu";
import { Select } from "components/ui/select";

import { languageOptions } from "client-server-shared/constants";
import { useShortId } from "hooks/use-short-id";
import { Tooltip } from "components/ui/tooltip";
import { Typography } from "components/ui/Typography";
import { useCommonTranslation } from "components/translate";
import { textEllipsis } from "modules/themes/styleUtils";

export const LanguageSelectionPlain = React.memo(
  ({
    title,
    onChange,
    value,
    useInternalState,
    hideTitle = false,
    rootProps,
    selectProps = {},
    required,
    optional,
    info,
  }) => {
    const [internalValue, setInternalValue] = React.useState(value);
    const onInternalValueChange = React.useCallback((e) => {
      setInternalValue(e.target.value);
    }, []);
    const { t } = useCommonTranslation();
    const id = useShortId();

    return (
      <>
        {hideTitle ? null : (
          <SectionTitle
            required={required}
            info={info}
            optional={optional}
            rootProps={{
              ...(rootProps || {}),
              sx: {
                width: "initial",
                ...(rootProps?.sx || {}),
              },
            }}
            id={id}
          >
            {title}
          </SectionTitle>
        )}
        <Select
          labelId={id}
          size="small"
          onChange={useInternalState ? onInternalValueChange : onChange}
          value={
            useInternalState
              ? internalValue || languageOptions[0].value
              : value || languageOptions[0].value
          }
          {...selectProps}
        >
          {languageOptions.map((lang) => {
            const displayLabel =
              lang.example && lang.value !== languageOptions[0].value
                ? `${lang.label}(${lang.example})`
                : `${lang.label}`;

            return (
              <MenuItem
                sx={{
                  cursor: "pointer",
                  opacity: 1,
                }}
                key={lang.value}
                value={lang.value}
              >
                <Typography
                  variant="body2"
                  sx={{
                    ...textEllipsis,
                    maxWidth: "100px",
                    fontSize: "12px",
                  }}
                >
                  {displayLabel}
                </Typography>
              </MenuItem>
            );
          })}
        </Select>
      </>
    );
  }
);
